var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('NavBar'),_c('div',{staticClass:"main-wrapper",class:{'home-main_wrapper': _vm.isHomePage}},[(!_vm.isHomePage)?_c('LeftMenu'):_vm._e(),_c('router-view')],1),_c('footer-section')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }